
export enum DialogType {
   PROCESSING = 'ProcessingDialog'
}
